import { Component } from 'react';
import PropTypes from 'prop-types';

import './SideMenu.css';

import { getStyleValue, ucfirst } from '../Helpers/Helpers';
import moment from 'moment';

import { Divider, List, ListItem, ListItemText, IconButton } from '@mui/material';
import { Check } from '@mui/icons-material';

import MenuOpen from '@mui/icons-material/MenuOpen';
import Menu from '@mui/icons-material/Menu';

class SideMenu extends Component {
	constructor(props) {
		super(props);

		this.state = {
			activeItem: decodeURIComponent(props.match.params.group) || '',
			isCollapsed: false,
		};

		// If URL changes, activeView is retrieved not from routing (props.match.params.group)
		// but directly from URL parts
		this.historyListener = props.history.listen((location) => {
			const urlParams = location.pathname.split('/');
			this.setState({
				activeItem: decodeURIComponent(urlParams[urlParams.length - 1]),
			});
		});
	}
	componentWillUnmount() {
		// Clean up listener
		this.historyListener();
	}

	generateSideMenuItems(menuItems) {
		const items = menuItems.map(({ name, parts }, index) => {
			const isItemActive = this.state.activeItem.toLowerCase() === name.toLowerCase();
			const partsWithStatusCount = parts && parts.filter(({ status }) => status).length;

			let menuItem = <ListItem
				button
				key={index}
				onClick={() => this.handleMenuItemClick(name) }
				className={ `side-menu__list-item ${ isItemActive ? 'side-menu__list-item--active' : '' }` }
			>
				<ListItemText
					primary={ucfirst(name)}
					secondary={parts && (partsWithStatusCount === parts.length
						? <Check />
						: `${partsWithStatusCount} / ${parts.length}`
					)}
				/>
			</ListItem>;

			if (name === 'Divider') {
				menuItem = <Divider key={index} style={{
					marginTop: getStyleValue('spacing-half'),
					marginBottom: getStyleValue('spacing-half'),
					backgroundColor: getStyleValue('color-text-grey'),
				}} />;
			}

			return menuItem;
		});

		return <List>{items}</List>;
	}
	handleMenuItemClick(item) {
		const { id, title } = this.props.match.params;
		const form = document.getElementById('inspection-form');

		this.props.submitForm(form, { validate: false, gotoNext: false });
		this.props.history.push(`/inspection/${id}/${title}/${encodeURIComponent(item)}`);
	}
	handleCollapseButton() {
		const newCollapsedStatus = !this.state.isCollapsed;
		this.setState({ isCollapsed: newCollapsedStatus });
		this.props.handleCollapse(newCollapsedStatus);
	}
	render() {
		let date = '';
		if (this.props.date) {
			date = moment(this.props.date).format('LL');
		}

		return (
			<div className={ `side-menu ${ this.state.isCollapsed ? 'side-menu--collapsed' : '' }` }>
				<IconButton
					className="collapse-button"
					color="primary"
					style={{ padding: '12px' }}
					onClick={ this.handleCollapseButton.bind(this) }>
					{ this.state.isCollapsed &&
						<Menu />
					}
					{ !this.state.isCollapsed &&
						<MenuOpen />
					}
				</IconButton>
				<div
					className="side-menu__content">
					<h3>{ this.props.t.inspection } <span>{date}</span></h3>
					{this.generateSideMenuItems(this.props.menuItems)}
				</div>
			</div>
		);
	}
}

SideMenu.propTypes = {
	date: PropTypes.string,
	menuItems: PropTypes.array.isRequired,
};

export default SideMenu;
